import { render, staticRenderFns } from "./authentication-translations-card.vue?vue&type=template&id=cf9d681a"
import script from "./authentication-translations-card.vue?vue&type=script&lang=js"
export * from "./authentication-translations-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports